import { notification_templates, replacer } from "@/lib/notifications";
import { useApiSend } from "@/react-queries/custom-request";
import { readNotification } from "@/react-queries/mutations/notifications";
import { NotificationType } from "@/react-queries/queries/notifications/types";
import { useTranslations } from "next-intl";
import { SetStateAction, useState } from "react";
import toast from "react-hot-toast";

const NotificationItem = ({ item, locale, setNotification }: { item: NotificationType; locale: string; setNotification: React.Dispatch<SetStateAction<NotificationType | undefined>>; }) => {
    const [viewed, setViewed] = useState(item.view);
    const { mutate } = useApiSend(readNotification,
        (data: { message: string; }) => { toast.success(data.message); setViewed(true); },
        (error: { message: string; }) => toast.error(error.message),
        ['notifications', item.id]
    );
    const translate = useTranslations('Header.notifications');

    const handleReadNotification = () => {
        if (!viewed) {
            // @ts-ignore
            mutate(item.id);
        }
        setNotification(item);
    };
    return (
        <div className="flex flex-col gap-2 p-2" onClick={handleReadNotification}>
            <p className="font-semibold text-sm flex justify-between gap-2 items-center">
                {item.title}
                {
                    item.view ?
                        <span className="px-2 py-1 text-xs rounded bg-emerald-500 text-white shrink-0 min-w-min">{translate('read')}</span>
                        : <span className="px-2 py-1 text-xs rounded bg-orange-500 text-white shrink-0 min-w-min">{translate('unread')}</span>
                }
            </p>
            {/* @ts-ignore */}
            <p className="text-gray-500 text-sm">{replacer(notification_templates[locale][item.type], item.items)}</p>
            <p className="flex items-center gap-1 text-xs uppercase">
                <span>{new Date(item.date).toLocaleDateString()}</span> |
                <span>{new Date(item.date).toLocaleTimeString()}</span>
            </p>
        </div>
    );
};

export default NotificationItem;